// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"181":"87008f78","511":"c9b3406a","897":"c05bb61d"}[chunkId] + ".js";
};